import { render } from "./NotFound.vue?vue&type=template&id=4cfb1f1f&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=4cfb1f1f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cfb1f1f"]])

export default __exports__